module.exports = __webpack_public_path__ + "static/media/blablacar.c7d3c348.jpg";